/**
     * 获取DPI
     * @returns {Array}
     */
// eslint-disable-next-line camelcase
function conversion_getDPI () {
  // eslint-disable-next-line no-array-constructor
  var arrDPI = new Array()
  if (window.screen.deviceXDPI) {
    arrDPI[0] = window.screen.deviceXDPI
    arrDPI[1] = window.screen.deviceYDPI
  } else {
    var tmpNode = document.createElement('DIV')
    tmpNode.style.cssText = 'width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden'
    document.body.appendChild(tmpNode)
    arrDPI[0] = parseInt(tmpNode.offsetWidth)
    arrDPI[1] = parseInt(tmpNode.offsetHeight)
    tmpNode.parentNode.removeChild(tmpNode)
  }
  return arrDPI
}
/**
     * px转换为mm
     * @param value
     * @returns {number}
     */
export function pxConversionMm (value) {
  var inch = value / conversion_getDPI()[0]
  // eslint-disable-next-line camelcase
  var c_value = inch * 25.4
  //      console.log(c_value);
  // eslint-disable-next-line camelcase
  return c_value
}
/**
     * mm转换为px
     * @param value
     * @returns {number}
     */
export function mmConversionPx (value) {
  var inch = value / 25.4
  // eslint-disable-next-line camelcase
  var c_value = inch * conversion_getDPI()[0]
  //      console.log(c_value);
  // eslint-disable-next-line camelcase
  return c_value
}



// WEBPACK FOOTER //
// ./src/utils/unitConversion.js